/** Public instance branding used to theme the login page and app chrome. */

import { apiFetch } from "./client";

/** The public branding subset (`GET /api/branding`). */
export interface Branding {
  product_name: string;
  /** CSS custom properties applied to `:root` (e.g. `{"--color-primary": "#1a4"}`). */
  theme: Record<string, string> | null;
  login_text: string | null;
  logo_path: string | null;
  locale: string;
}

/** Fetch the instance's public branding. */
export function getBranding(): Promise<Branding> {
  return apiFetch<Branding>("/api/branding");
}
